import React, { useState } from "react";
import { IconButton } from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import CloseIcon from "@mui/icons-material/Close";
import PrintIcon from "@mui/icons-material/Print";
import FormattedDate from "@egovernments/digit-ui-module-obps/src/components/TimeStamp";
import SafeHtml from "@egovernments/digit-ui-module-common/src/sharedComponents/SafeHtml";
import { getDocumentByFileStoreId } from "@egovernments/digit-ui-libraries/src/utils/fileType";

const NOCDetailsLog = ({ logData, nocRemarksData }) => {
  const termsAndCondition = Digit.SessionStorage.get("nocTermsAndCondition", logData);
  console.log("logDataNOC", logData, termsAndCondition, nocRemarksData);
  let user = Digit.UserService.getUser();

  const isCitizen = user?.info?.type === "CITIZEN";
  const detailsArray = !isCitizen ? nocRemarksData?.DetailDataRemarks : termsAndCondition?.DetailDataRemarks;
  const userDetails = Digit.SessionStorage.get("USER_DETAIL");

  const { nocAppNo, nocSearchResult } = Digit.SessionStorage.get("nocAppNo") || {};

  const nocCurrentFormData = isCitizen
    ? logData?.nocList.find((item) => item.applicationNo == nocAppNo)
    : logData?.nocList.find((n) => n.businessService == userDetails?.organisationCode);
  const [popupData, setPopupData] = useState(null);
  const [showPopup, setShowPopup] = useState(false);
  const [showDocsPopup, setShowDocsPopup] = useState(false);
  const [docsContextItem, setDocsContextItem] = useState(null);
  const [isPreviewLoading, setIsPreviewLoading] = useState(false);

  const openPopup = (item) => {
    setPopupData(item);
    setShowPopup(true);
  };

  const openDocsPopup = (item) => {
    setDocsContextItem(item);
    setShowDocsPopup(true);
  };

  const closePopup = () => {
    setShowPopup(false);
    setPopupData(null);
  };

  const closeDocsPopup = () => {
    setShowDocsPopup(false);
    setDocsContextItem(null);
  };

  const handleLoadDocument = async (fileStoreId) => {
    try {
      await getDocumentByFileStoreId(fileStoreId, setIsPreviewLoading);
    } catch (error) {
      console.error("Error loading document:", error);
    }
  };

  const printPopup = () => {
    const popupContent = document.getElementById("noc-popup-print");
    if (!popupContent) return;

    const printWindow = window.open("", "_blank", "width=800,height=600");
    printWindow.document.write(`
      <html>
        <head>
          <title>Print NOC Details</title>
          <style>
            body { font-size: 12px; font-family: Arial; }
            table { width: 100%; border-collapse: collapse; }
            th, td { border: 1px solid #ccc; padding: 6px; }
            th { background-color: #f0f0f0; }
          </style>
        </head>
        <body>
          ${popupContent.innerHTML}
        </body>
      </html>
    `);
    printWindow.document.close();
    printWindow.focus();
    printWindow.print();
    printWindow.close();
  };

  return (
    <div>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "10px" }}>
        <h3 style={{ fontWeight: "bold", margin: 0 }}>NOC Details Log</h3>
      </div>
      <div style={{ overflowX: "auto", maxHeight: "300px", overflowY: "scroll" }}>
        <table
          border="1"
          cellPadding="8"
          width="100%"
          style={{
            borderCollapse: "collapse",
            minWidth: "600px",
            fontSize: "11px",
            position: "relative",
          }}
        >
          <thead style={{ backgroundColor: "rgba(52, 73, 94, 0.94)", position: "sticky", top: 0, zIndex: 2 }}>
            <tr style={{ fontSize: "14px", backgroundColor: "rgba(52, 73, 94, 0.94)", color: "#fff" }}>
              <th>Department</th>
              <th>Department Remarks</th>
              <th>LTP Remarks</th>
              <th>Date & Time</th>
              <th>View</th>
            </tr>
          </thead>
          <tbody>
            {detailsArray?.map((item, index) => {
              const user = item?.userDetails || {};
              const createdTime = item?.auditDetails?.createdTime || null;
              // Show correct remarks based on isCitizen
              const departmentRemarks = item?.nocOfficerRemarks;
              const myRemarks = item?.applicantRemarks;
              return (
                <tr key={index}>
                  <td>{departmentRemarks ? nocCurrentFormData?.nocName : "Licensed Technical Professional"}</td>
                  <SafeHtml html={departmentRemarks || "-"} tag="td" />
                  <SafeHtml html={myRemarks || "-"} tag="td" />
                  <td>
                    <FormattedDate timestamp={createdTime} />
                  </td>
                  <td>
                    {item?.documentDetailsLtp && item.documentDetailsLtp.length > 0 ? (
                      <IconButton onClick={() => openDocsPopup(item)} size="small" title="View Documents">
                        <VisibilityIcon fontSize="small" />
                      </IconButton>
                    ) : (
                      "-"
                    )}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      {/* Popup */}
      {showPopup && (
        <div
          style={{
            position: "fixed",
            top: "15%",
            left: "50%",
            transform: "translateX(-50%)",
            backgroundColor: "#fff",
            border: "1px solid #ccc",
            padding: "20px",
            zIndex: 1000,
            maxHeight: "80vh",
            overflowY: "auto",
            width: "60%",
            boxShadow: "0 0 10px rgba(0,0,0,0.3)",
            fontSize: "12px",
          }}
        >
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <h3>NOC Details Info</h3>
            <div>
              <IconButton onClick={printPopup} title="Print">
                <PrintIcon />
              </IconButton>
              <IconButton onClick={closePopup} title="Close">
                <CloseIcon />
              </IconButton>
            </div>
          </div>

          <div id="noc-popup-print">
            {popupData?.userDetails && (
              <div style={{ marginBottom: "10px" }}>
                <strong>User:</strong> {popupData.userDetails?.employeeName || popupData.userDetails?.name || "-"} | <strong>Designation:</strong>{" "}
                {popupData.userDetails?.designation || "-"} | <strong>Created:</strong>{" "}
                <FormattedDate timestamp={popupData.auditDetails?.createdTime} />
              </div>
            )}

            <table border="1" cellPadding="6" width="100%" style={{ borderCollapse: "collapse", fontSize: "12px" }}>
              <thead style={{ backgroundColor: "#e2e8f0" }}>
                <tr>
                  <th>Department</th>
                  <th>Application Number</th>
                  <th>Status</th>
                  <th>Comments</th>
                </tr>
              </thead>
              <tbody>
                {(popupData?.nocDetails || []).map((noc, i) => (
                  <tr key={i}>
                    <td>{noc?.department || "-"}</td>
                    <td>{noc?.applicationNumber || "-"}</td>
                    <td>{noc?.status || "-"}</td>
                    <td>{popupData?.nocRemarks ? <SafeHtml html={popupData.nocRemarks} /> : "-"}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {showDocsPopup && (
        <div
          style={{
            position: "fixed",
            top: "15%",
            left: "50%",
            transform: "translateX(-50%)",
            backgroundColor: "#fff",
            border: "1px solid #ccc",
            padding: "20px",
            zIndex: 1000,
            maxHeight: "80vh",
            overflowY: "auto",
            width: "70%",
            boxShadow: "0 0 10px rgba(0,0,0,0.3)",
            fontSize: "12px",
          }}
        >
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <h3 style={{ fontSize: "14px", margin: 0 }}>Documents</h3>
            <IconButton onClick={closeDocsPopup} title="Close">
              <CloseIcon />
            </IconButton>
          </div>

          <table border="1" cellPadding="6" width="100%" style={{ borderCollapse: "collapse", fontSize: "12px", marginTop: "10px" }}>
            <thead style={{ backgroundColor: "#e2e8f0" }}>
              <tr>
                <th>Title</th>
                <th>Document Id</th>

                <th>View</th>
              </tr>
            </thead>
            <tbody>
              {(docsContextItem?.documentDetailsLtp || []).map((row, i) => (
                <tr key={i}>
                  <td>{row?.fileName || row?.documentTitle || row?.documentType || "-"}</td>
                  <td>{row?.fileStoreId || "-"}</td>
                  <td>
                    {row?.fileStoreId ? (
                      <IconButton onClick={() => handleLoadDocument(row.fileStoreId)} size="small" title="View Document" style={{ padding: "4px" }}>
                        <VisibilityIcon fontSize="small" style={{ color: "#157CB3" }} />
                      </IconButton>
                    ) : (
                      "-"
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default NOCDetailsLog;
